import "vite/modulepreload-polyfill";
import { createRoot } from "react-dom/client";
import { ProjectListWidget } from "./Components/ProjectList.jsx";

export function RenderProjects(configuration){
    const container = document.getElementById(configuration.container);
    const root = createRoot(container);

    root.render(
      (
        <ProjectListWidget configuration={configuration} />
      ),
    );
}


document.addEventListener("DOMContentLoaded", function() {
    const widget_configs = document.querySelectorAll(".project-list-widget-config");

    for (let config of widget_configs) {
        RenderProjects(JSON.parse(config.innerText));
    }
});
